/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import Model from '@tripian/model';
import CustomPopover from '../../base/CustomPopover/CustomPopover';
import StepTimes from '../../StepTimes/StepTimes';
import TimelineAddPoiModal from '../../TimelineAddPoiModal/TimelineAddPoiModal';
import XIcon from '../../base/Svg/Icons/X';
import classes from './PoiActionButton.scss';

enum POI_CARD_ACTION {
  ADD,
  REPLACE,
  REMOVE,
}

interface PoiActionButtonProps {
  poi: Model.Poi;
  hideActionButtons: boolean;
  replace: boolean;
  stepOrder: number;
  partOfDay?: string;
  className?: string;
  addRemoveReplacePoi: (poi: Model.Poi, removeReplaceAdd: number, from?: string, to?: string) => void;
  t: (value: Model.TranslationKey) => string;
  // Timeline mode props
  plans?: Model.Plan[];
  currentDayIndex?: number;
  onTimelineAdd?: (planId: number, poiId: string, from?: string, to?: string) => void;
}

const PoiActionButton: React.FC<PoiActionButtonProps> = ({ poi, hideActionButtons, replace, stepOrder, addRemoveReplacePoi, partOfDay, t, className = '', plans, currentDayIndex, onTimelineAdd }) => {
  const [show, setShow] = useState(false);

  if (hideActionButtons) return null;

  const isTimelineMode = plans && plans.length > 0 && currentDayIndex !== undefined && onTimelineAdd;

  let ACTION_FLAG: POI_CARD_ACTION;
  if (replace) {
    ACTION_FLAG = POI_CARD_ACTION.REPLACE;
  } else if (stepOrder > -1) {
    ACTION_FLAG = POI_CARD_ACTION.REMOVE;
  } else {
    ACTION_FLAG = POI_CARD_ACTION.ADD;
  }

  const actionIconClasses = [classes.addRemoveReplaceIcon];
  if (ACTION_FLAG === POI_CARD_ACTION.ADD) {
    actionIconClasses.push(classes.addIcon);
  } else if (ACTION_FLAG === POI_CARD_ACTION.REPLACE) {
    actionIconClasses.push(classes.replaceIcon);
  } else if (ACTION_FLAG === POI_CARD_ACTION.REMOVE) {
    actionIconClasses.push(classes.removeIcon);
  }

  if (ACTION_FLAG === POI_CARD_ACTION.ADD) {
    if (isTimelineMode) {
      return (
        <div className={className}>
          <input
            key={`${poi.id}-${ACTION_FLAG}`}
            type="button"
            className={actionIconClasses.join(' ')}
            onClick={(e) => {
              e.stopPropagation();
              setShow((prevShow) => !prevShow);
            }}
          />
          {show && (
            <TimelineAddPoiModal
              poi={poi}
              plans={plans}
              currentDayIndex={currentDayIndex}
              onAdd={(planId, poiId, from, to) => {
                onTimelineAdd(planId, poiId, from, to);
                setShow(false);
              }}
              onClose={() => setShow(false)}
              t={t}
            />
          )}
        </div>
      );
    }

    return (
      <div className={className}>
        <CustomPopover
          show={show}
          content={
            <StepTimes
              times={{
                from: undefined,
                to: undefined,
              }}
              timesClicked={(from?: string, to?: string) => {
                addRemoveReplacePoi(poi, 1, from, to);
                setShow(false);
              }}
              buttonText={t('trips.myTrips.itinerary.step.addToItinerary.submit.apply')}
              duration={poi.duration}
              onClose={() => setShow(false)}
              t={t}
            />
          }
          backdropClick={(e) => {
            e.stopPropagation();
            if (show) setShow(false);
          }}
        >
          <input
            key={`${poi.id}-${ACTION_FLAG}`}
            type="button"
            className={actionIconClasses.join(' ')}
            onClick={(e) => {
              e.stopPropagation();
              setShow((prevShow) => !prevShow);
            }}
          />
        </CustomPopover>
      </div>
    );
  }

  if (ACTION_FLAG === POI_CARD_ACTION.REMOVE) {
    return (
      <div className={className}>
        <div role="button" tabIndex={0} className={actionIconClasses.join(' ')} onClick={() => addRemoveReplacePoi(poi, -1)} onKeyPress={() => addRemoveReplacePoi(poi, -1)}>
          <span>{`${t('trips.myTrips.itinerary.day')} ${String(partOfDay)}`}</span>
          <XIcon width="16" height="16" fill="#008000" />
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <input
        type="button"
        className={actionIconClasses.join(' ')}
        onClick={() => {
          if (ACTION_FLAG === POI_CARD_ACTION.REPLACE) addRemoveReplacePoi(poi, 0);
        }}
      />
    </div>
  );
};

export default PoiActionButton;